import * as d from "react";
import { jsx as a, jsxs as l, Fragment as he } from "react/jsx-runtime";
import * as O from "@radix-ui/react-accordion";
import { ChevronDownIcon as V, MoreHorizontal as xe, ChevronRight as de, ChevronLeftIcon as we, ChevronRightIcon as q, CheckIcon as $, XIcon as le, SearchIcon as ye, CircleIcon as W, Minus as Ne, ChevronLeft as ke, GripVerticalIcon as ze, ChevronUpIcon as Ce, PanelLeftIcon as _e, Loader2Icon as Se, X as Ie } from "lucide-react";
import { clsx as Te } from "clsx";
import { twMerge as Me } from "tailwind-merge";
import { cva as T } from "class-variance-authority";
import * as M from "@radix-ui/react-alert-dialog";
import { Slot as R } from "@radix-ui/react-slot";
import * as Re from "@radix-ui/react-aspect-ratio";
import * as Z from "@radix-ui/react-avatar";
import { getDefaultClassNames as ce, DayPicker as Pe } from "react-day-picker";
import * as ee from "recharts";
import * as oe from "@radix-ui/react-checkbox";
import * as te from "@radix-ui/react-collapsible";
import { Command as B } from "cmdk";
import { Dialog as C } from "radix-ui";
import * as b from "@radix-ui/react-context-menu";
import * as v from "@radix-ui/react-dropdown-menu";
import * as De from "@radix-ui/react-label";
import { FormProvider as Ae, Controller as je, useFormContext as Be, useFormState as Le } from "react-hook-form";
import * as K from "@radix-ui/react-hover-card";
import { OTPInput as Ge, OTPInputContext as Oe } from "input-otp";
import * as h from "@radix-ui/react-menubar";
import * as P from "@radix-ui/react-navigation-menu";
import * as F from "@radix-ui/react-popover";
import * as ne from "@radix-ui/react-progress";
import * as J from "@radix-ui/react-radio-group";
import * as ae from "react-resizable-panels";
import * as G from "@radix-ui/react-scroll-area";
import * as x from "@radix-ui/react-select";
import * as Fe from "@radix-ui/react-separator";
import * as I from "@radix-ui/react-dialog";
import * as L from "@radix-ui/react-tooltip";
import * as H from "@radix-ui/react-slider";
import * as ie from "@radix-ui/react-switch";
import { useTheme as Ee } from "next-themes";
import { Toaster as Ve } from "sonner";
import * as N from "@radix-ui/react-toast";
import * as $e from "@radix-ui/react-toggle";
const Y = 768;
function He() {
  const [e, t] = d.useState(
    void 0
  );
  return d.useEffect(() => {
    const r = window.matchMedia(`(max-width: ${Y - 1}px)`), n = () => {
      t(window.innerWidth < Y);
    };
    return r.addEventListener("change", n), t(window.innerWidth < Y), () => r.removeEventListener("change", n);
  }, []), !!e;
}
function o(...e) {
  return Me(Te(e));
}
function wa({
  ...e
}) {
  return /* @__PURE__ */ a(O.Root, { "data-slot": "accordion", ...e });
}
function ya({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    O.Item,
    {
      "data-slot": "accordion-item",
      className: o("border-b last:border-b-0", e),
      ...t
    }
  );
}
function Na({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ a(O.Header, { className: "flex", children: /* @__PURE__ */ l(
    O.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: o(
        "focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ a(V, { className: "text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" })
      ]
    }
  ) });
}
function ka({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    O.Content,
    {
      "data-slot": "accordion-content",
      className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      ...r,
      children: /* @__PURE__ */ a("div", { className: o("pt-0 pb-4", e), children: t })
    }
  );
}
const Ke = T(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function za({
  className: e,
  variant: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: o(Ke({ variant: t }), e),
      ...r
    }
  );
}
function Ca({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-title",
      className: o(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        e
      ),
      ...t
    }
  );
}
function _a({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-description",
      className: o(
        "text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
        e
      ),
      ...t
    }
  );
}
const E = T(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
        "icon-sm": "size-6"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), S = d.forwardRef(
  ({ className: e, variant: t, size: r, asChild: n = !1, ...i }, c) => /* @__PURE__ */ a(
    n ? R : "button",
    {
      className: o(E({ variant: t, size: r, className: e })),
      ref: c,
      ...i
    }
  )
);
S.displayName = "Button";
function Sa({
  ...e
}) {
  return /* @__PURE__ */ a(M.Root, { "data-slot": "alert-dialog", ...e });
}
function Ia({
  ...e
}) {
  return /* @__PURE__ */ a(M.Trigger, { "data-slot": "alert-dialog-trigger", ...e });
}
function qe({
  ...e
}) {
  return /* @__PURE__ */ a(M.Portal, { "data-slot": "alert-dialog-portal", ...e });
}
function We({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    M.Overlay,
    {
      "data-slot": "alert-dialog-overlay",
      className: o(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function Ta({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ l(qe, { children: [
    /* @__PURE__ */ a(We, {}),
    /* @__PURE__ */ a(
      M.Content,
      {
        "data-slot": "alert-dialog-content",
        className: o(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg",
          e
        ),
        ...t
      }
    )
  ] });
}
function Ma({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: o("flex flex-col gap-2 text-center sm:text-left", e),
      ...t
    }
  );
}
function Ra({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: o(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function Pa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    M.Title,
    {
      "data-slot": "alert-dialog-title",
      className: o("text-lg font-semibold", e),
      ...t
    }
  );
}
function Da({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    M.Description,
    {
      "data-slot": "alert-dialog-description",
      className: o("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function Aa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    M.Action,
    {
      className: o(E(), e),
      ...t
    }
  );
}
function ja({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    M.Cancel,
    {
      className: o(E({ variant: "outline" }), e),
      ...t
    }
  );
}
function Ba({
  ...e
}) {
  return /* @__PURE__ */ a(Re.Root, { "data-slot": "aspect-ratio", ...e });
}
function La({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    Z.Root,
    {
      "data-slot": "avatar",
      className: o(
        "relative flex size-8 shrink-0 overflow-hidden rounded-full",
        e
      ),
      ...t
    }
  );
}
function Ga({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    Z.Image,
    {
      "data-slot": "avatar-image",
      className: o("aspect-square size-full", e),
      ...t
    }
  );
}
function Oa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    Z.Fallback,
    {
      "data-slot": "avatar-fallback",
      className: o(
        "bg-muted flex size-full items-center justify-center rounded-full",
        e
      ),
      ...t
    }
  );
}
const Ue = T(
  "inline-flex items-center justify-center rounded-full border border-transparent px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
        secondary: "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive: "bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        link: "text-primary underline-offset-4 [a&]:hover:underline"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Fa({
  className: e,
  variant: t = "default",
  asChild: r = !1,
  ...n
}) {
  return /* @__PURE__ */ a(
    r ? R : "span",
    {
      "data-slot": "badge",
      "data-variant": t,
      className: o(Ue({ variant: t }), e),
      ...n
    }
  );
}
const Xe = d.forwardRef(({ ...e }, t) => /* @__PURE__ */ a("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
Xe.displayName = "Breadcrumb";
const Ye = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "ol",
  {
    ref: r,
    className: o(
      "text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5",
      e
    ),
    ...t
  }
));
Ye.displayName = "BreadcrumbList";
const Je = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "li",
  {
    ref: r,
    className: o("inline-flex items-center gap-1.5", e),
    ...t
  }
));
Je.displayName = "BreadcrumbItem";
const Qe = d.forwardRef(({ asChild: e, className: t, ...r }, n) => /* @__PURE__ */ a(
  e ? R : "a",
  {
    ref: n,
    className: o("hover:text-foreground transition-colors", t),
    ...r
  }
));
Qe.displayName = "BreadcrumbLink";
const Ze = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "span",
  {
    ref: r,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: o("text-foreground font-normal", e),
    ...t
  }
));
Ze.displayName = "BreadcrumbPage";
const et = ({
  children: e,
  className: t,
  ...r
}) => /* @__PURE__ */ a(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: o("[&>svg]:h-3.5 [&>svg]:w-3.5", t),
    ...r,
    children: e ?? /* @__PURE__ */ a(de, {})
  }
);
et.displayName = "BreadcrumbSeparator";
const tt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: o("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ a(xe, { className: "h-4 w-4" }),
      /* @__PURE__ */ a("span", { className: "sr-only", children: "More" })
    ]
  }
);
tt.displayName = "BreadcrumbElipssis";
function Ea({
  className: e,
  classNames: t,
  showOutsideDays: r = !0,
  captionLayout: n = "label",
  buttonVariant: i = "ghost",
  formatters: c,
  components: u,
  ...m
}) {
  const s = ce();
  return /* @__PURE__ */ a(
    Pe,
    {
      showOutsideDays: r,
      className: o(
        "bg-background group/calendar p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: n,
      formatters: {
        formatMonthDropdown: (f) => f.toLocaleString("default", { month: "short" }),
        ...c
      },
      classNames: {
        root: o("w-fit", s.root),
        months: o(
          "flex gap-4 flex-col md:flex-row relative",
          s.months
        ),
        month: o("flex flex-col w-full gap-4", s.month),
        nav: o(
          "flex items-center gap-1 w-full absolute top-0 inset-x-0 justify-between",
          s.nav
        ),
        button_previous: o(
          E({ variant: i }),
          "size-(--cell-size) aria-disabled:opacity-50 p-0 select-none",
          s.button_previous
        ),
        button_next: o(
          E({ variant: i }),
          "size-(--cell-size) aria-disabled:opacity-50 p-0 select-none",
          s.button_next
        ),
        month_caption: o(
          "flex items-center justify-center h-(--cell-size) w-full px-(--cell-size)",
          s.month_caption
        ),
        dropdowns: o(
          "w-full flex items-center text-sm font-medium justify-center h-(--cell-size) gap-1.5",
          s.dropdowns
        ),
        dropdown_root: o(
          "relative has-focus:border-ring border border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] rounded-md",
          s.dropdown_root
        ),
        dropdown: o(
          "absolute bg-popover inset-0 opacity-0",
          s.dropdown
        ),
        caption_label: o(
          "select-none font-medium",
          n === "label" ? "text-sm" : "rounded-md pl-2 pr-1 flex items-center gap-1 text-sm h-8 [&>svg]:text-muted-foreground [&>svg]:size-3.5",
          s.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: o("flex", s.weekdays),
        weekday: o(
          "text-muted-foreground rounded-md flex-1 font-normal text-[0.8rem] select-none",
          s.weekday
        ),
        week: o("flex w-full mt-2", s.week),
        week_number_header: o(
          "select-none w-(--cell-size)",
          s.week_number_header
        ),
        week_number: o(
          "text-[0.8rem] select-none text-muted-foreground",
          s.week_number
        ),
        day: o(
          "relative w-full h-full p-0 text-center [&:first-child[data-selected=true]_button]:rounded-l-md [&:last-child[data-selected=true]_button]:rounded-r-md group/day aspect-square select-none",
          s.day
        ),
        range_start: o(
          "rounded-l-md bg-accent",
          s.range_start
        ),
        range_middle: o("rounded-none", s.range_middle),
        range_end: o("rounded-r-md bg-accent", s.range_end),
        today: o(
          "bg-accent text-accent-foreground rounded-md data-[selected=true]:rounded-none",
          s.today
        ),
        outside: o(
          "text-muted-foreground aria-selected:text-muted-foreground",
          s.outside
        ),
        disabled: o(
          "text-muted-foreground opacity-50",
          s.disabled
        ),
        hidden: o("invisible", s.hidden),
        ...t
      },
      components: {
        Root: ({ className: f, rootRef: g, ...k }) => /* @__PURE__ */ a(
          "div",
          {
            "data-slot": "calendar",
            ref: g,
            className: o(f),
            ...k
          }
        ),
        Chevron: ({ className: f, orientation: g, ...k }) => g === "left" ? /* @__PURE__ */ a(we, { className: o("size-4", f), ...k }) : g === "right" ? /* @__PURE__ */ a(
          q,
          {
            className: o("size-4", f),
            ...k
          }
        ) : /* @__PURE__ */ a(V, { className: o("size-4", f), ...k }),
        DayButton: at,
        WeekNumber: ({ children: f, ...g }) => /* @__PURE__ */ a("td", { ...g, children: /* @__PURE__ */ a("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: f }) }),
        ...u
      },
      ...m
    }
  );
}
function at({
  className: e,
  day: t,
  modifiers: r,
  ...n
}) {
  const i = ce(), c = d.useRef(null);
  return d.useEffect(() => {
    r.focused && c.current?.focus();
  }, [r.focused]), /* @__PURE__ */ a(
    S,
    {
      ref: c,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(),
      "data-selected-single": r.selected && !r.range_start && !r.range_end && !r.range_middle,
      "data-range-start": r.range_start,
      "data-range-end": r.range_end,
      "data-range-middle": r.range_middle,
      className: o(
        "data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 dark:hover:text-accent-foreground flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] data-[range-end=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md data-[range-start=true]:rounded-l-md [&>span]:text-xs [&>span]:opacity-70",
        i.day,
        e
      ),
      ...n
    }
  );
}
function Va({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card",
      className: o(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6",
        e
      ),
      ...t
    }
  );
}
function $a({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-header",
      className: o(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        e
      ),
      ...t
    }
  );
}
function Ha({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-title",
      className: o("leading-none font-semibold", e),
      ...t
    }
  );
}
function Ka({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-description",
      className: o("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function qa({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-action",
      className: o(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function Wa({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-content",
      className: o("px-6", e),
      ...t
    }
  );
}
function Ua({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-footer",
      className: o("flex items-center px-6 [.border-t]:pt-6", e),
      ...t
    }
  );
}
const rt = { light: "", dark: ".dark" }, ue = d.createContext(null);
function me() {
  const e = d.useContext(ue);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
function Xa({
  id: e,
  className: t,
  children: r,
  config: n,
  ...i
}) {
  const c = d.useId(), u = `chart-${e || c.replace(/:/g, "")}`;
  return /* @__PURE__ */ a(ue.Provider, { value: { config: n }, children: /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "chart",
      "data-chart": u,
      className: o(
        "[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-hidden",
        t
      ),
      ...i,
      children: [
        /* @__PURE__ */ a(ot, { id: u, config: n }),
        /* @__PURE__ */ a(ee.ResponsiveContainer, { children: r })
      ]
    }
  ) });
}
const ot = ({ id: e, config: t }) => {
  const r = Object.entries(t).filter(
    ([, n]) => n.theme || n.color
  );
  return r.length ? /* @__PURE__ */ a(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(rt).map(
          ([n, i]) => `
${i} [data-chart=${e}] {
${r.map(([c, u]) => {
            const m = u.theme?.[n] || u.color;
            return m ? `  --color-${c}: ${m};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}, Ya = ee.Tooltip;
function Ja({
  active: e,
  payload: t,
  className: r,
  indicator: n = "dot",
  hideLabel: i = !1,
  hideIndicator: c = !1,
  label: u,
  labelFormatter: m,
  labelClassName: s,
  formatter: f,
  color: g,
  nameKey: k,
  labelKey: y
}) {
  const { config: _ } = me(), D = d.useMemo(() => {
    if (i || !t?.length)
      return null;
    const [p] = t, w = `${y || p?.dataKey || p?.name || "value"}`, z = Q(_, p, w), j = !y && typeof u == "string" ? _[u]?.label || u : z?.label;
    return m ? /* @__PURE__ */ a("div", { className: o("font-medium", s), children: m(j, t) }) : j ? /* @__PURE__ */ a("div", { className: o("font-medium", s), children: j }) : null;
  }, [
    u,
    m,
    t,
    i,
    s,
    _,
    y
  ]);
  if (!e || !t?.length)
    return null;
  const A = t.length === 1 && n !== "dot";
  return /* @__PURE__ */ l(
    "div",
    {
      className: o(
        "border-border/50 bg-background grid min-w-[8rem] items-start gap-1.5 rounded-lg border px-2.5 py-1.5 text-xs shadow-xl",
        r
      ),
      children: [
        A ? null : D,
        /* @__PURE__ */ a("div", { className: "grid gap-1.5", children: t.map((p, w) => {
          const z = `${k || p.name || p.dataKey || "value"}`, j = Q(_, p, z), re = g || p.payload.fill || p.color;
          return /* @__PURE__ */ a(
            "div",
            {
              className: o(
                "[&>svg]:text-muted-foreground flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5",
                n === "dot" && "items-center"
              ),
              children: f && p?.value !== void 0 && p.name ? f(p.value, p.name, p, w, p.payload) : /* @__PURE__ */ l(he, { children: [
                j?.icon ? /* @__PURE__ */ a(j.icon, {}) : !c && /* @__PURE__ */ a(
                  "div",
                  {
                    className: o(
                      "shrink-0 rounded-[2px] border-(--color-border) bg-(--color-bg)",
                      {
                        "h-2.5 w-2.5": n === "dot",
                        "w-1": n === "line",
                        "w-0 border-[1.5px] border-dashed bg-transparent": n === "dashed",
                        "my-0.5": A && n === "dashed"
                      }
                    ),
                    style: {
                      "--color-bg": re,
                      "--color-border": re
                    }
                  }
                ),
                /* @__PURE__ */ l(
                  "div",
                  {
                    className: o(
                      "flex flex-1 justify-between leading-none",
                      A ? "items-end" : "items-center"
                    ),
                    children: [
                      /* @__PURE__ */ l("div", { className: "grid gap-1.5", children: [
                        A ? D : null,
                        /* @__PURE__ */ a("span", { className: "text-muted-foreground", children: j?.label || p.name })
                      ] }),
                      p.value && /* @__PURE__ */ a("span", { className: "text-foreground font-mono font-medium tabular-nums", children: p.value.toLocaleString() })
                    ]
                  }
                )
              ] })
            },
            p.dataKey
          );
        }) })
      ]
    }
  );
}
const Qa = ee.Legend;
function Za({
  className: e,
  hideIcon: t = !1,
  payload: r,
  verticalAlign: n = "bottom",
  nameKey: i
}) {
  const { config: c } = me();
  return r?.length ? /* @__PURE__ */ a(
    "div",
    {
      className: o(
        "flex items-center justify-center gap-4",
        n === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: r.map((u) => {
        const m = `${i || u.dataKey || "value"}`, s = Q(c, u, m);
        return /* @__PURE__ */ l(
          "div",
          {
            className: o(
              "[&>svg]:text-muted-foreground flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3"
            ),
            children: [
              s?.icon && !t ? /* @__PURE__ */ a(s.icon, {}) : /* @__PURE__ */ a(
                "div",
                {
                  className: "h-2 w-2 shrink-0 rounded-[2px]",
                  style: {
                    backgroundColor: u.color
                  }
                }
              ),
              s?.label
            ]
          },
          u.value
        );
      })
    }
  ) : null;
}
function Q(e, t, r) {
  if (typeof t != "object" || t === null)
    return;
  const n = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0;
  let i = r;
  return r in t && typeof t[r] == "string" ? i = t[r] : n && r in n && typeof n[r] == "string" && (i = n[r]), i in e ? e[i] : e[r];
}
function er({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    oe.Root,
    {
      "data-slot": "checkbox",
      className: o(
        "peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        oe.Indicator,
        {
          "data-slot": "checkbox-indicator",
          className: "flex items-center justify-center text-current transition-none",
          children: /* @__PURE__ */ a($, { className: "size-3.5" })
        }
      )
    }
  );
}
function tr({
  ...e
}) {
  return /* @__PURE__ */ a(te.Root, { "data-slot": "collapsible", ...e });
}
function ar({
  ...e
}) {
  return /* @__PURE__ */ a(
    te.CollapsibleTrigger,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function rr({
  ...e
}) {
  return /* @__PURE__ */ a(
    te.CollapsibleContent,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function nt({
  ...e
}) {
  return /* @__PURE__ */ a(C.Root, { "data-slot": "dialog", ...e });
}
function or({
  ...e
}) {
  return /* @__PURE__ */ a(C.Trigger, { "data-slot": "dialog-trigger", ...e });
}
function it({
  ...e
}) {
  return /* @__PURE__ */ a(C.Portal, { "data-slot": "dialog-portal", ...e });
}
function nr({
  ...e
}) {
  return /* @__PURE__ */ a(C.Close, { "data-slot": "dialog-close", ...e });
}
function st({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    C.Overlay,
    {
      "data-slot": "dialog-overlay",
      className: o(
        "data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs",
        e
      ),
      ...t
    }
  );
}
function dt({
  className: e,
  children: t,
  showCloseButton: r = !0,
  ...n
}) {
  return /* @__PURE__ */ l(it, { children: [
    /* @__PURE__ */ a(st, {}),
    /* @__PURE__ */ l(
      C.Content,
      {
        "data-slot": "dialog-content",
        className: o(
          "bg-background data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 ring-foreground/10 fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl p-4 text-sm ring-1 duration-100 sm:max-w-sm",
          e
        ),
        ...n,
        children: [
          t,
          r && /* @__PURE__ */ a(C.Close, { "data-slot": "dialog-close", asChild: !0, children: /* @__PURE__ */ l(
            S,
            {
              variant: "ghost",
              className: "absolute top-2 right-2",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ a(le, {}),
                /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function lt({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "dialog-header",
      className: o("mr-6 flex flex-col gap-2", e),
      ...t
    }
  );
}
function ir({
  className: e,
  showCloseButton: t = !1,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "dialog-footer",
      className: o(
        "bg-muted/50 -mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t p-4 sm:flex-row sm:justify-end",
        e
      ),
      ...n,
      children: [
        r,
        t && /* @__PURE__ */ a(C.Close, { asChild: !0, children: /* @__PURE__ */ a(S, { variant: "outline", children: "Close" }) })
      ]
    }
  );
}
function ct({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    C.Title,
    {
      "data-slot": "dialog-title",
      className: o("text-base leading-none font-medium", e),
      ...t
    }
  );
}
function ut({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    C.Description,
    {
      "data-slot": "dialog-description",
      className: o(
        "text-muted-foreground *:[a]:hover:text-foreground text-sm *:[a]:underline *:[a]:underline-offset-3",
        e
      ),
      ...t
    }
  );
}
function mt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    B,
    {
      "data-slot": "command",
      className: o(
        "bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md",
        e
      ),
      ...t
    }
  );
}
function sr({
  title: e = "Command Palette",
  description: t = "Search for a command to run...",
  children: r,
  className: n,
  showCloseButton: i = !0,
  ...c
}) {
  return /* @__PURE__ */ l(nt, { ...c, children: [
    /* @__PURE__ */ l(lt, { className: "sr-only", children: [
      /* @__PURE__ */ a(ct, { children: e }),
      /* @__PURE__ */ a(ut, { children: t })
    ] }),
    /* @__PURE__ */ a(
      dt,
      {
        className: o("overflow-hidden p-0", n),
        showCloseButton: i,
        children: /* @__PURE__ */ a(mt, { className: "[&_[cmdk-group-heading]]:text-muted-foreground **:data-[slot=command-input-wrapper]:h-12 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: r })
      }
    )
  ] });
}
function dr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex h-9 w-full items-center gap-2 border-b-0 px-3",
      children: [
        /* @__PURE__ */ a(ye, { className: "size-4 shrink-0 opacity-50" }),
        /* @__PURE__ */ a(
          B.Input,
          {
            "data-slot": "command-input",
            className: o(
              "placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function lr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    B.List,
    {
      "data-slot": "command-list",
      className: o(
        "max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto",
        e
      ),
      ...t
    }
  );
}
function cr({
  ...e
}) {
  return /* @__PURE__ */ a(
    B.Empty,
    {
      "data-slot": "command-empty",
      className: "py-6 text-center text-sm",
      ...e
    }
  );
}
function ur({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    B.Group,
    {
      "data-slot": "command-group",
      className: o(
        "text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium",
        e
      ),
      ...t
    }
  );
}
function mr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    B.Separator,
    {
      "data-slot": "command-separator",
      className: o("bg-border -mx-1 h-px", e),
      ...t
    }
  );
}
function fr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    B.Item,
    {
      "data-slot": "command-item",
      className: o(
        "data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function pr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "command-shortcut",
      className: o(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
function gr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Root, { "data-slot": "context-menu", ...e });
}
function br({
  ...e
}) {
  return /* @__PURE__ */ a(b.Trigger, { "data-slot": "context-menu-trigger", ...e });
}
function vr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Group, { "data-slot": "context-menu-group", ...e });
}
function hr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Portal, { "data-slot": "context-menu-portal", ...e });
}
function xr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Sub, { "data-slot": "context-menu-sub", ...e });
}
function wr({
  ...e
}) {
  return /* @__PURE__ */ a(
    b.RadioGroup,
    {
      "data-slot": "context-menu-radio-group",
      ...e
    }
  );
}
function yr({
  className: e,
  inset: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    b.SubTrigger,
    {
      "data-slot": "context-menu-sub-trigger",
      "data-inset": t,
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(q, { className: "ml-auto" })
      ]
    }
  );
}
function Nr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    b.SubContent,
    {
      "data-slot": "context-menu-sub-content",
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-context-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        e
      ),
      ...t
    }
  );
}
function kr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(b.Portal, { children: /* @__PURE__ */ a(
    b.Content,
    {
      "data-slot": "context-menu-content",
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-context-menu-content-available-height) min-w-[8rem] origin-(--radix-context-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
        e
      ),
      ...t
    }
  ) });
}
function zr({
  className: e,
  inset: t,
  variant: r = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    b.Item,
    {
      "data-slot": "context-menu-item",
      "data-inset": t,
      "data-variant": r,
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n
    }
  );
}
function Cr({
  className: e,
  children: t,
  checked: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    b.CheckboxItem,
    {
      "data-slot": "context-menu-checkbox-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: r,
      ...n,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(b.ItemIndicator, { children: /* @__PURE__ */ a($, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function _r({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    b.RadioItem,
    {
      "data-slot": "context-menu-radio-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(b.ItemIndicator, { children: /* @__PURE__ */ a(W, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function Sr({
  className: e,
  inset: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    b.Label,
    {
      "data-slot": "context-menu-label",
      "data-inset": t,
      className: o(
        "text-foreground px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...r
    }
  );
}
function Ir({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    b.Separator,
    {
      "data-slot": "context-menu-separator",
      className: o("bg-border -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function Tr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "context-menu-shortcut",
      className: o(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
function Mr({
  ...e
}) {
  return /* @__PURE__ */ a(v.Root, { "data-slot": "dropdown-menu", ...e });
}
function Rr({
  ...e
}) {
  return /* @__PURE__ */ a(v.Portal, { "data-slot": "dropdown-menu-portal", ...e });
}
function Pr({
  ...e
}) {
  return /* @__PURE__ */ a(
    v.Trigger,
    {
      "data-slot": "dropdown-menu-trigger",
      ...e
    }
  );
}
function Dr({
  className: e,
  sideOffset: t = 4,
  ...r
}) {
  return /* @__PURE__ */ a(v.Portal, { children: /* @__PURE__ */ a(
    v.Content,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: t,
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
        e
      ),
      ...r
    }
  ) });
}
function Ar({
  ...e
}) {
  return /* @__PURE__ */ a(v.Group, { "data-slot": "dropdown-menu-group", ...e });
}
function jr({
  className: e,
  inset: t,
  variant: r = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    v.Item,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": r,
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n
    }
  );
}
function Br({
  className: e,
  children: t,
  checked: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    v.CheckboxItem,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: r,
      ...n,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(v.ItemIndicator, { children: /* @__PURE__ */ a($, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function Lr({
  ...e
}) {
  return /* @__PURE__ */ a(
    v.RadioGroup,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function Gr({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    v.RadioItem,
    {
      "data-slot": "dropdown-menu-radio-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(v.ItemIndicator, { children: /* @__PURE__ */ a(W, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function Or({
  className: e,
  inset: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    v.Label,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: o(
        "px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...r
    }
  );
}
function Fr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    v.Separator,
    {
      "data-slot": "dropdown-menu-separator",
      className: o("bg-border -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function Er({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: o(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
function Vr({
  ...e
}) {
  return /* @__PURE__ */ a(v.Sub, { "data-slot": "dropdown-menu-sub", ...e });
}
function $r({
  className: e,
  inset: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    v.SubTrigger,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(q, { className: "ml-auto size-4" })
      ]
    }
  );
}
function Hr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    v.SubContent,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        e
      ),
      ...t
    }
  );
}
function ft({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    De.Root,
    {
      "data-slot": "label",
      className: o(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
const Kr = Ae, fe = d.createContext(
  {}
), qr = ({
  ...e
}) => /* @__PURE__ */ a(fe.Provider, { value: { name: e.name }, children: /* @__PURE__ */ a(je, { ...e }) }), U = () => {
  const e = d.useContext(fe), t = d.useContext(pe), { getFieldState: r } = Be(), n = Le({ name: e.name }), i = r(e.name, n);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: c } = t;
  return {
    id: c,
    name: e.name,
    formItemId: `${c}-form-item`,
    formDescriptionId: `${c}-form-item-description`,
    formMessageId: `${c}-form-item-message`,
    ...i
  };
}, pe = d.createContext(
  {}
);
function Wr({ className: e, ...t }) {
  const r = d.useId();
  return /* @__PURE__ */ a(pe.Provider, { value: { id: r }, children: /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "form-item",
      className: o("grid gap-2", e),
      ...t
    }
  ) });
}
function Ur({
  className: e,
  ...t
}) {
  const { error: r, formItemId: n } = U();
  return /* @__PURE__ */ a(
    ft,
    {
      "data-slot": "form-label",
      "data-error": !!r,
      className: o("data-[error=true]:text-destructive", e),
      htmlFor: n,
      ...t
    }
  );
}
function Xr({ ...e }) {
  const { error: t, formItemId: r, formDescriptionId: n, formMessageId: i } = U();
  return /* @__PURE__ */ a(
    R,
    {
      "data-slot": "form-control",
      id: r,
      "aria-describedby": t ? `${n} ${i}` : `${n}`,
      "aria-invalid": !!t,
      ...e
    }
  );
}
function Yr({ className: e, ...t }) {
  const { formDescriptionId: r } = U();
  return /* @__PURE__ */ a(
    "p",
    {
      "data-slot": "form-description",
      id: r,
      className: o("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function Jr({ className: e, ...t }) {
  const { error: r, formMessageId: n } = U(), i = r ? String(r?.message ?? "") : t.children;
  return i ? /* @__PURE__ */ a(
    "p",
    {
      "data-slot": "form-message",
      id: n,
      className: o("text-destructive text-sm", e),
      ...t,
      children: i
    }
  ) : null;
}
function Qr({
  ...e
}) {
  return /* @__PURE__ */ a(K.Root, { "data-slot": "hover-card", ...e });
}
function Zr({
  ...e
}) {
  return /* @__PURE__ */ a(K.Trigger, { "data-slot": "hover-card-trigger", ...e });
}
function eo({
  className: e,
  align: t = "center",
  sideOffset: r = 4,
  ...n
}) {
  return /* @__PURE__ */ a(K.Portal, { "data-slot": "hover-card-portal", children: /* @__PURE__ */ a(
    K.Content,
    {
      "data-slot": "hover-card-content",
      align: t,
      sideOffset: r,
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 origin-(--radix-hover-card-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...n
    }
  ) });
}
function ge({ className: e, type: t, ...r }) {
  return /* @__PURE__ */ a(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: o(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        e
      ),
      ...r
    }
  );
}
function pt({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "textarea",
    {
      "data-slot": "textarea",
      className: o(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ...t
    }
  );
}
function to({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: o(
        "group/input-group border-input dark:bg-input/30 relative flex w-full items-center rounded-md border shadow-xs transition-[color,box-shadow] outline-none",
        "h-9 min-w-0 has-[>textarea]:h-auto",
        // Variants based on alignment.
        "has-[>[data-align=inline-start]]:[&>input]:pl-2",
        "has-[>[data-align=inline-end]]:[&>input]:pr-2",
        "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3",
        "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3",
        // Focus state.
        "has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot=input-group-control]:focus-visible]:ring-[3px]",
        // Error state.
        "has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
const gt = T(
  "text-muted-foreground flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium select-none [&>svg:not([class*='size-'])]:size-4 [&>kbd]:rounded-[calc(var(--radius)-5px)] group-data-[disabled=true]/input-group:opacity-50",
  {
    variants: {
      align: {
        "inline-start": "order-first pl-3 has-[>button]:ml-[-0.45rem] has-[>kbd]:ml-[-0.35rem]",
        "inline-end": "order-last pr-3 has-[>button]:mr-[-0.45rem] has-[>kbd]:mr-[-0.35rem]",
        "block-start": "order-first w-full justify-start px-3 pt-3 [.border-b]:pb-3 group-has-[>input]/input-group:pt-2.5",
        "block-end": "order-last w-full justify-start px-3 pb-3 [.border-t]:pt-3 group-has-[>input]/input-group:pb-2.5"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function ao({
  className: e,
  align: t = "inline-start",
  ...r
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: o(gt({ align: t }), e),
      onClick: (n) => {
        n.target.closest("button") || n.currentTarget.parentElement?.querySelector("input")?.focus();
      },
      ...r
    }
  );
}
const bt = T(
  "text-sm shadow-none flex gap-2 items-center",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 px-2 rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-3.5 has-[>svg]:px-2",
        sm: "h-8 px-2.5 gap-1.5 rounded-md has-[>svg]:px-2.5",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-5px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function ro({
  className: e,
  type: t = "button",
  variant: r = "ghost",
  size: n = "xs",
  ...i
}) {
  return /* @__PURE__ */ a(
    S,
    {
      type: t,
      "data-size": n,
      variant: r,
      className: o(bt({ size: n }), e),
      ...i
    }
  );
}
function oo({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "span",
    {
      className: o(
        "text-muted-foreground flex items-center gap-2 text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function no({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    ge,
    {
      "data-slot": "input-group-control",
      className: o(
        "flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function io({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    pt,
    {
      "data-slot": "input-group-control",
      className: o(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-3 shadow-none focus-visible:ring-0 dark:bg-transparent",
        e
      ),
      ...t
    }
  );
}
const vt = d.forwardRef(({ className: e, containerClassName: t, ...r }, n) => /* @__PURE__ */ a(
  Ge,
  {
    ref: n,
    containerClassName: o(
      "flex items-center gap-2 has-[:disabled]:opacity-50",
      t
    ),
    className: o("disabled:cursor-not-allowed", e),
    ...r
  }
));
vt.displayName = "InputOTP";
const ht = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a("div", { ref: r, className: o("flex items-center", e), ...t }));
ht.displayName = "InputOTPGroup";
const xt = d.forwardRef(({ index: e, className: t, ...r }, n) => {
  const i = d.useContext(Oe), { char: c, hasFakeCaret: u, isActive: m } = i.slots[e];
  return /* @__PURE__ */ l(
    "div",
    {
      ref: n,
      className: o(
        "border-input relative flex h-9 w-9 items-center justify-center border-y border-r text-sm shadow-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
        m && "ring-ring z-10 ring-1",
        t
      ),
      ...r,
      children: [
        c,
        u && /* @__PURE__ */ a("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ a("div", { className: "animate-caret-blink bg-foreground h-4 w-px duration-1000" }) })
      ]
    }
  );
});
xt.displayName = "InputOTPSlot";
const wt = d.forwardRef(({ ...e }, t) => /* @__PURE__ */ a("div", { ref: t, role: "separator", ...e, children: /* @__PURE__ */ a(Ne, {}) }));
wt.displayName = "InputOTPSeparator";
function so({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Root,
    {
      "data-slot": "menubar",
      className: o(
        "bg-background flex h-9 items-center gap-1 rounded-md border p-1 shadow-xs",
        e
      ),
      ...t
    }
  );
}
function lo({
  ...e
}) {
  return /* @__PURE__ */ a(h.Menu, { "data-slot": "menubar-menu", ...e });
}
function co({
  ...e
}) {
  return /* @__PURE__ */ a(h.Group, { "data-slot": "menubar-group", ...e });
}
function yt({
  ...e
}) {
  return /* @__PURE__ */ a(h.Portal, { "data-slot": "menubar-portal", ...e });
}
function uo({
  ...e
}) {
  return /* @__PURE__ */ a(h.RadioGroup, { "data-slot": "menubar-radio-group", ...e });
}
function mo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Trigger,
    {
      "data-slot": "menubar-trigger",
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex items-center rounded-sm px-2 py-1 text-sm font-medium outline-hidden select-none",
        e
      ),
      ...t
    }
  );
}
function fo({
  className: e,
  align: t = "start",
  alignOffset: r = -4,
  sideOffset: n = 8,
  ...i
}) {
  return /* @__PURE__ */ a(yt, { children: /* @__PURE__ */ a(
    h.Content,
    {
      "data-slot": "menubar-content",
      align: t,
      alignOffset: r,
      sideOffset: n,
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[12rem] origin-(--radix-menubar-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-md",
        e
      ),
      ...i
    }
  ) });
}
function po({
  className: e,
  inset: t,
  variant: r = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    h.Item,
    {
      "data-slot": "menubar-item",
      "data-inset": t,
      "data-variant": r,
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n
    }
  );
}
function go({
  className: e,
  children: t,
  checked: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    h.CheckboxItem,
    {
      "data-slot": "menubar-checkbox-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: r,
      ...n,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(h.ItemIndicator, { children: /* @__PURE__ */ a($, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function bo({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    h.RadioItem,
    {
      "data-slot": "menubar-radio-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(h.ItemIndicator, { children: /* @__PURE__ */ a(W, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function vo({
  className: e,
  inset: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    h.Label,
    {
      "data-slot": "menubar-label",
      "data-inset": t,
      className: o(
        "px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...r
    }
  );
}
function ho({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Separator,
    {
      "data-slot": "menubar-separator",
      className: o("bg-border -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function xo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "menubar-shortcut",
      className: o(
        "text-muted-foreground ml-auto text-xs tracking-widest",
        e
      ),
      ...t
    }
  );
}
function wo({
  ...e
}) {
  return /* @__PURE__ */ a(h.Sub, { "data-slot": "menubar-sub", ...e });
}
function yo({
  className: e,
  inset: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    h.SubTrigger,
    {
      "data-slot": "menubar-sub-trigger",
      "data-inset": t,
      className: o(
        "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-none select-none data-[inset]:pl-8",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(q, { className: "ml-auto h-4 w-4" })
      ]
    }
  );
}
function No({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.SubContent,
    {
      "data-slot": "menubar-sub-content",
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-menubar-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        e
      ),
      ...t
    }
  );
}
function ko({
  className: e,
  children: t,
  viewport: r = !0,
  ...n
}) {
  return /* @__PURE__ */ l(
    P.Root,
    {
      "data-slot": "navigation-menu",
      "data-viewport": r,
      className: o(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        e
      ),
      ...n,
      children: [
        t,
        r && /* @__PURE__ */ a(kt, {})
      ]
    }
  );
}
function zo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    P.List,
    {
      "data-slot": "navigation-menu-list",
      className: o(
        "group flex flex-1 list-none items-center justify-center gap-1",
        e
      ),
      ...t
    }
  );
}
function Co({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    P.Item,
    {
      "data-slot": "navigation-menu-item",
      className: o("relative", e),
      ...t
    }
  );
}
const Nt = T(
  "group inline-flex h-9 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=open]:hover:bg-accent data-[state=open]:text-accent-foreground data-[state=open]:focus:bg-accent data-[state=open]:bg-accent/50 focus-visible:ring-ring/50 outline-none transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1"
);
function _o({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    P.Trigger,
    {
      "data-slot": "navigation-menu-trigger",
      className: o(Nt(), "group", e),
      ...r,
      children: [
        t,
        " ",
        /* @__PURE__ */ a(
          V,
          {
            className: "relative top-[1px] ml-1 size-3 transition duration-300 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
}
function So({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    P.Content,
    {
      "data-slot": "navigation-menu-content",
      className: o(
        "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 top-0 left-0 w-full p-2 pr-2.5 md:absolute md:w-auto",
        "group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:data-[state=open]:animate-in group-data-[viewport=false]/navigation-menu:data-[state=closed]:animate-out group-data-[viewport=false]/navigation-menu:data-[state=closed]:zoom-out-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:zoom-in-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:fade-in-0 group-data-[viewport=false]/navigation-menu:data-[state=closed]:fade-out-0 group-data-[viewport=false]/navigation-menu:top-full group-data-[viewport=false]/navigation-menu:mt-1.5 group-data-[viewport=false]/navigation-menu:overflow-hidden group-data-[viewport=false]/navigation-menu:rounded-md group-data-[viewport=false]/navigation-menu:border group-data-[viewport=false]/navigation-menu:shadow group-data-[viewport=false]/navigation-menu:duration-200 **:data-[slot=navigation-menu-link]:focus:ring-0 **:data-[slot=navigation-menu-link]:focus:outline-none",
        e
      ),
      ...t
    }
  );
}
function kt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: o(
        "absolute top-full left-0 isolate z-50 flex justify-center"
      ),
      children: /* @__PURE__ */ a(
        P.Viewport,
        {
          "data-slot": "navigation-menu-viewport",
          className: o(
            "origin-top-center bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border shadow md:w-[var(--radix-navigation-menu-viewport-width)]",
            e
          ),
          ...t
        }
      )
    }
  );
}
function Io({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    P.Link,
    {
      "data-slot": "navigation-menu-link",
      className: o(
        "data-[active=true]:focus:bg-accent data-[active=true]:hover:bg-accent data-[active=true]:bg-accent/50 data-[active=true]:text-accent-foreground hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus-visible:ring-ring/50 [&_svg:not([class*='text-'])]:text-muted-foreground flex flex-col gap-1 rounded-sm p-2 text-sm transition-all outline-none focus-visible:ring-[3px] focus-visible:outline-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function To({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    P.Indicator,
    {
      "data-slot": "navigation-menu-indicator",
      className: o(
        "data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
    }
  );
}
function Mo({
  currentPage: e,
  pageCount: t,
  onPageChange: r
}) {
  const n = e > 0, i = e < t - 1, c = e + 1, m = (() => {
    const s = [];
    if (t <= 5)
      for (let g = 1; g <= t; g++)
        s.push(g);
    else {
      let g = Math.max(1, c - 2), k = Math.min(t, c + 2);
      c <= 3 ? k = Math.min(t, 5) : c >= t - 2 && (g = Math.max(1, t - 4));
      for (let y = g; y <= k; y++)
        s.push(y);
    }
    return s;
  })();
  return /* @__PURE__ */ l("div", { className: "flex items-center justify-center space-x-1 py-4", children: [
    /* @__PURE__ */ l(
      S,
      {
        variant: "outline",
        className: "h-10 w-10 cursor-pointer rounded-lg border-gray-300 p-0 hover:bg-gray-50",
        onClick: () => r(e - 1),
        disabled: !n,
        children: [
          /* @__PURE__ */ a("span", { className: "sr-only", children: "الصفحة السابقة" }),
          /* @__PURE__ */ a(de, { className: "h-4 w-4" })
        ]
      }
    ),
    m.map((s) => /* @__PURE__ */ a(
      S,
      {
        variant: s === c ? "default" : "outline",
        className: `h-10 w-10 cursor-pointer rounded-lg p-0 ${s === c ? "border-green-500 bg-green-500 text-white hover:bg-green-600" : "border-gray-300 text-gray-700 hover:bg-gray-50"}`,
        onClick: () => r(s - 1),
        children: s
      },
      s
    )),
    /* @__PURE__ */ l(
      S,
      {
        variant: "outline",
        className: "h-10 w-10 cursor-pointer rounded-lg border-gray-300 p-0 hover:bg-gray-50",
        onClick: () => r(e + 1),
        disabled: !i,
        children: [
          /* @__PURE__ */ a("span", { className: "sr-only", children: "الصفحة التالية" }),
          /* @__PURE__ */ a(ke, { className: "h-4 w-4" })
        ]
      }
    )
  ] });
}
function Ro({
  ...e
}) {
  return /* @__PURE__ */ a(F.Root, { "data-slot": "popover", ...e });
}
function Po({
  ...e
}) {
  return /* @__PURE__ */ a(F.Trigger, { "data-slot": "popover-trigger", ...e });
}
function Do({
  className: e,
  align: t = "center",
  sideOffset: r = 4,
  ...n
}) {
  return /* @__PURE__ */ a(F.Portal, { children: /* @__PURE__ */ a(
    F.Content,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: r,
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...n
    }
  ) });
}
function Ao({
  ...e
}) {
  return /* @__PURE__ */ a(F.Anchor, { "data-slot": "popover-anchor", ...e });
}
function jo({
  className: e,
  value: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    ne.Root,
    {
      "data-slot": "progress",
      className: o(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        e
      ),
      ...r,
      children: /* @__PURE__ */ a(
        ne.Indicator,
        {
          "data-slot": "progress-indicator",
          className: "bg-primary h-full w-full flex-1 transition-all",
          style: { transform: `translateX(-${100 - (t || 0)}%)` }
        }
      )
    }
  );
}
function Bo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    J.Root,
    {
      "data-slot": "radio-group",
      className: o("grid gap-3", e),
      ...t
    }
  );
}
function Lo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    J.Item,
    {
      "data-slot": "radio-group-item",
      className: o(
        "border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        J.Indicator,
        {
          "data-slot": "radio-group-indicator",
          className: "relative flex items-center justify-center",
          children: /* @__PURE__ */ a(W, { className: "fill-primary absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" })
        }
      )
    }
  );
}
function Go({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    ae.PanelGroup,
    {
      "data-slot": "resizable-panel-group",
      className: o(
        "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
        e
      ),
      ...t
    }
  );
}
function Oo({
  ...e
}) {
  return /* @__PURE__ */ a(ae.Panel, { "data-slot": "resizable-panel", ...e });
}
function Fo({
  withHandle: e,
  className: t,
  ...r
}) {
  return /* @__PURE__ */ a(
    ae.PanelResizeHandle,
    {
      "data-slot": "resizable-handle",
      className: o(
        "bg-border focus-visible:ring-ring relative flex w-px items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-hidden data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:translate-x-0 data-[panel-group-direction=vertical]:after:-translate-y-1/2 [&[data-panel-group-direction=vertical]>div]:rotate-90",
        t
      ),
      ...r,
      children: e && /* @__PURE__ */ a("div", { className: "bg-border z-10 flex h-4 w-3 items-center justify-center rounded-xs border", children: /* @__PURE__ */ a(ze, { className: "size-2.5" }) })
    }
  );
}
function Eo({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    G.Root,
    {
      "data-slot": "scroll-area",
      className: o("relative", e),
      ...r,
      children: [
        /* @__PURE__ */ a(
          G.Viewport,
          {
            "data-slot": "scroll-area-viewport",
            className: "focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ a(zt, {}),
        /* @__PURE__ */ a(G.Corner, {})
      ]
    }
  );
}
function zt({
  className: e,
  orientation: t = "vertical",
  ...r
}) {
  return /* @__PURE__ */ a(
    G.ScrollAreaScrollbar,
    {
      "data-slot": "scroll-area-scrollbar",
      orientation: t,
      className: o(
        "flex touch-none p-px transition-colors select-none",
        t === "vertical" && "h-full w-2.5 border-l border-l-transparent",
        t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent",
        e
      ),
      ...r,
      children: /* @__PURE__ */ a(
        G.ScrollAreaThumb,
        {
          "data-slot": "scroll-area-thumb",
          className: "bg-border relative flex-1 rounded-full"
        }
      )
    }
  );
}
function Vo({
  ...e
}) {
  return /* @__PURE__ */ a(x.Root, { "data-slot": "select", ...e });
}
function $o({
  ...e
}) {
  return /* @__PURE__ */ a(x.Group, { "data-slot": "select-group", ...e });
}
function Ho({
  ...e
}) {
  return /* @__PURE__ */ a(x.Value, { "data-slot": "select-value", ...e });
}
function Ko({
  className: e,
  size: t = "default",
  children: r,
  ...n
}) {
  return /* @__PURE__ */ l(
    x.Trigger,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: o(
        "border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(x.Icon, { asChild: !0, children: /* @__PURE__ */ a(V, { className: "size-4 opacity-50" }) })
      ]
    }
  );
}
function qo({
  className: e,
  children: t,
  position: r = "popper",
  ...n
}) {
  return /* @__PURE__ */ a(x.Portal, { children: /* @__PURE__ */ l(
    x.Content,
    {
      "data-slot": "select-content",
      className: o(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md",
        r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: r,
      ...n,
      children: [
        /* @__PURE__ */ a(Ct, {}),
        /* @__PURE__ */ a(
          x.Viewport,
          {
            className: o(
              "p-1",
              r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ a(_t, {})
      ]
    }
  ) });
}
function Wo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    x.Label,
    {
      "data-slot": "select-label",
      className: o("text-muted-foreground px-2 py-1.5 text-xs", e),
      ...t
    }
  );
}
function Uo({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    x.Item,
    {
      "data-slot": "select-item",
      className: o(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ a("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(x.ItemIndicator, { children: /* @__PURE__ */ a($, { className: "size-4" }) }) }),
        /* @__PURE__ */ a(x.ItemText, { children: t })
      ]
    }
  );
}
function Xo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    x.Separator,
    {
      "data-slot": "select-separator",
      className: o("bg-border pointer-events-none -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function Ct({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    x.ScrollUpButton,
    {
      "data-slot": "select-scroll-up-button",
      className: o(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(Ce, { className: "size-4" })
    }
  );
}
function _t({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    x.ScrollDownButton,
    {
      "data-slot": "select-scroll-down-button",
      className: o(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(V, { className: "size-4" })
    }
  );
}
function St({
  className: e,
  orientation: t = "horizontal",
  decorative: r = !0,
  ...n
}) {
  return /* @__PURE__ */ a(
    Fe.Root,
    {
      "data-slot": "separator-root",
      decorative: r,
      orientation: t,
      className: o(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        e
      ),
      ...n
    }
  );
}
function It({ ...e }) {
  return /* @__PURE__ */ a(I.Root, { "data-slot": "sheet", ...e });
}
function Yo({
  ...e
}) {
  return /* @__PURE__ */ a(I.Trigger, { "data-slot": "sheet-trigger", ...e });
}
function Jo({
  ...e
}) {
  return /* @__PURE__ */ a(I.Close, { "data-slot": "sheet-close", ...e });
}
function Tt({
  ...e
}) {
  return /* @__PURE__ */ a(I.Portal, { "data-slot": "sheet-portal", ...e });
}
function Mt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    I.Overlay,
    {
      "data-slot": "sheet-overlay",
      className: o(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function Rt({
  className: e,
  children: t,
  side: r = "right",
  ...n
}) {
  return /* @__PURE__ */ l(Tt, { children: [
    /* @__PURE__ */ a(Mt, {}),
    /* @__PURE__ */ l(
      I.Content,
      {
        "data-slot": "sheet-content",
        className: o(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
          r === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm",
          r === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm",
          r === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b",
          r === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t",
          e
        ),
        ...n,
        children: [
          t,
          /* @__PURE__ */ l(I.Close, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none", children: [
            /* @__PURE__ */ a(le, { className: "size-4" }),
            /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function Pt({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sheet-header",
      className: o("flex flex-col gap-1.5 p-4", e),
      ...t
    }
  );
}
function Qo({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sheet-footer",
      className: o("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function Dt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    I.Title,
    {
      "data-slot": "sheet-title",
      className: o("text-foreground font-semibold", e),
      ...t
    }
  );
}
function At({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    I.Description,
    {
      "data-slot": "sheet-description",
      className: o("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function se({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: o("bg-primary/10 animate-pulse rounded-md", e),
      ...t
    }
  );
}
function be({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ a(
    L.Provider,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function jt({
  ...e
}) {
  return /* @__PURE__ */ a(be, { children: /* @__PURE__ */ a(L.Root, { "data-slot": "tooltip", ...e }) });
}
function Bt({
  ...e
}) {
  return /* @__PURE__ */ a(L.Trigger, { "data-slot": "tooltip-trigger", ...e });
}
function Lt({
  className: e,
  sideOffset: t = 0,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ a(L.Portal, { children: /* @__PURE__ */ l(
    L.Content,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: o(
        "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ a(L.Arrow, { className: "bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
const Gt = "sidebar_state", Ot = 3600 * 24 * 7, Ft = "16rem", Et = "18rem", Vt = "3rem", $t = "b", ve = d.createContext(null);
function X() {
  const e = d.useContext(ve);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function Zo({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: r,
  className: n,
  style: i,
  children: c,
  ...u
}) {
  const m = He(), [s, f] = d.useState(!1), [g, k] = d.useState(e), y = t ?? g, _ = d.useCallback(
    (w) => {
      const z = typeof w == "function" ? w(y) : w;
      r ? r(z) : k(z), document.cookie = `${Gt}=${z}; path=/; max-age=${Ot}`;
    },
    [r, y]
  ), D = d.useCallback(() => m ? f((w) => !w) : _((w) => !w), [m, _, f]);
  d.useEffect(() => {
    const w = (z) => {
      z.key === $t && (z.metaKey || z.ctrlKey) && (z.preventDefault(), D());
    };
    return window.addEventListener("keydown", w), () => window.removeEventListener("keydown", w);
  }, [D]);
  const A = y ? "expanded" : "collapsed", p = d.useMemo(
    () => ({
      state: A,
      open: y,
      setOpen: _,
      isMobile: m,
      openMobile: s,
      setOpenMobile: f,
      toggleSidebar: D
    }),
    [A, y, _, m, s, f, D]
  );
  return /* @__PURE__ */ a(ve.Provider, { value: p, children: /* @__PURE__ */ a(be, { delayDuration: 0, children: /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-wrapper",
      style: {
        "--sidebar-width": Ft,
        "--sidebar-width-icon": Vt,
        ...i
      },
      className: o(
        "group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full",
        n
      ),
      ...u,
      children: c
    }
  ) }) });
}
function en({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: r = "offcanvas",
  className: n,
  children: i,
  ...c
}) {
  const { isMobile: u, state: m, openMobile: s, setOpenMobile: f } = X();
  return r === "none" ? /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar",
      className: o(
        "bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col",
        n
      ),
      ...c,
      children: i
    }
  ) : u ? /* @__PURE__ */ a(It, { open: s, onOpenChange: f, ...c, children: /* @__PURE__ */ l(
    Rt,
    {
      "data-sidebar": "sidebar",
      "data-slot": "sidebar",
      "data-mobile": "true",
      className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
      style: {
        "--sidebar-width": Et
      },
      side: e,
      children: [
        /* @__PURE__ */ l(Pt, { className: "sr-only", children: [
          /* @__PURE__ */ a(Dt, { children: "Sidebar" }),
          /* @__PURE__ */ a(At, { children: "Displays the mobile sidebar." })
        ] }),
        /* @__PURE__ */ a("div", { className: "flex h-full w-full flex-col", children: i })
      ]
    }
  ) }) : /* @__PURE__ */ l(
    "div",
    {
      className: "group peer text-sidebar-foreground hidden md:block",
      "data-state": m,
      "data-collapsible": m === "collapsed" ? r : "",
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            "data-slot": "sidebar-gap",
            className: o(
              "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
            )
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            "data-slot": "sidebar-container",
            className: o(
              "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              n
            ),
            ...c,
            children: /* @__PURE__ */ a(
              "div",
              {
                "data-sidebar": "sidebar",
                "data-slot": "sidebar-inner",
                className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm",
                children: i
              }
            )
          }
        )
      ]
    }
  );
}
function tn({
  className: e,
  onClick: t,
  ...r
}) {
  const { toggleSidebar: n } = X();
  return /* @__PURE__ */ l(
    S,
    {
      "data-sidebar": "trigger",
      "data-slot": "sidebar-trigger",
      variant: "ghost",
      size: "icon",
      className: o("size-7", e),
      onClick: (i) => {
        t?.(i), n();
      },
      ...r,
      children: [
        /* @__PURE__ */ a(_e, {}),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
}
function an({ className: e, ...t }) {
  const { toggleSidebar: r } = X();
  return /* @__PURE__ */ a(
    "button",
    {
      "data-sidebar": "rail",
      "data-slot": "sidebar-rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: r,
      title: "Toggle Sidebar",
      className: o(
        "hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear group-data-[side=left]:-right-4 group-data-[side=right]:left-0 after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] sm:flex",
        "in-data-[side=left]:cursor-w-resize in-data-[side=right]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "hover:group-data-[collapsible=offcanvas]:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
}
function rn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: o(
        "bg-background relative flex w-full flex-1 flex-col",
        "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2",
        e
      ),
      ...t
    }
  );
}
function on({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    ge,
    {
      "data-slot": "sidebar-input",
      "data-sidebar": "input",
      className: o("bg-background h-8 w-full shadow-none", e),
      ...t
    }
  );
}
function nn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: o("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function sn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-footer",
      "data-sidebar": "footer",
      className: o("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function dn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    St,
    {
      "data-slot": "sidebar-separator",
      "data-sidebar": "separator",
      className: o("bg-sidebar-border mx-2 w-auto", e),
      ...t
    }
  );
}
function ln({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: o(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    }
  );
}
function cn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: o("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    }
  );
}
function un({
  className: e,
  asChild: t = !1,
  ...r
}) {
  return /* @__PURE__ */ a(
    t ? R : "div",
    {
      "data-slot": "sidebar-group-label",
      "data-sidebar": "group-label",
      className: o(
        "text-sidebar-foreground/70 ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium outline-hidden transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
        e
      ),
      ...r
    }
  );
}
function mn({
  className: e,
  asChild: t = !1,
  ...r
}) {
  return /* @__PURE__ */ a(
    t ? R : "button",
    {
      "data-slot": "sidebar-group-action",
      "data-sidebar": "group-action",
      className: o(
        "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground absolute top-3.5 right-3 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 md:after:hidden",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...r
    }
  );
}
function fn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-group-content",
      "data-sidebar": "group-content",
      className: o("w-full text-sm", e),
      ...t
    }
  );
}
function pn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: o("flex w-full min-w-0 flex-col gap-1", e),
      ...t
    }
  );
}
function gn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: o("group/menu-item relative", e),
      ...t
    }
  );
}
const Ht = T(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function bn({
  asChild: e = !1,
  isActive: t = !1,
  variant: r = "default",
  size: n = "default",
  tooltip: i,
  className: c,
  ...u
}) {
  const m = e ? R : "button", { isMobile: s, state: f } = X(), g = /* @__PURE__ */ a(
    m,
    {
      "data-slot": "sidebar-menu-button",
      "data-sidebar": "menu-button",
      "data-size": n,
      "data-active": t,
      className: o(Ht({ variant: r, size: n }), c),
      ...u
    }
  );
  return i ? (typeof i == "string" && (i = {
    children: i
  }), /* @__PURE__ */ l(jt, { children: [
    /* @__PURE__ */ a(Bt, { asChild: !0, children: g }),
    /* @__PURE__ */ a(
      Lt,
      {
        side: "right",
        align: "center",
        hidden: f !== "collapsed" || s,
        ...i
      }
    )
  ] })) : g;
}
function vn({
  className: e,
  asChild: t = !1,
  showOnHover: r = !1,
  ...n
}) {
  return /* @__PURE__ */ a(
    t ? R : "button",
    {
      "data-slot": "sidebar-menu-action",
      "data-sidebar": "menu-action",
      className: o(
        "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute top-1.5 right-1 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 md:after:hidden",
        "peer-data-[size=sm]/menu-button:top-1",
        "peer-data-[size=default]/menu-button:top-1.5",
        "peer-data-[size=lg]/menu-button:top-2.5",
        "group-data-[collapsible=icon]:hidden",
        r && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0",
        e
      ),
      ...n
    }
  );
}
function hn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-menu-badge",
      "data-sidebar": "menu-badge",
      className: o(
        "text-sidebar-foreground pointer-events-none absolute right-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums select-none",
        "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
        "peer-data-[size=sm]/menu-button:top-1",
        "peer-data-[size=default]/menu-button:top-1.5",
        "peer-data-[size=lg]/menu-button:top-2.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function xn({
  className: e,
  showIcon: t = !1,
  ...r
}) {
  const [n] = d.useState(
    () => `${Math.floor(Math.random() * 40) + 50}%`
  );
  return /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "sidebar-menu-skeleton",
      "data-sidebar": "menu-skeleton",
      className: o("flex h-8 items-center gap-2 rounded-md px-2", e),
      ...r,
      children: [
        t && /* @__PURE__ */ a(
          se,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ a(
          se,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": n
            }
          }
        )
      ]
    }
  );
}
function wn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "ul",
    {
      "data-slot": "sidebar-menu-sub",
      "data-sidebar": "menu-sub",
      className: o(
        "border-sidebar-border mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l px-2.5 py-0.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function yn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "li",
    {
      "data-slot": "sidebar-menu-sub-item",
      "data-sidebar": "menu-sub-item",
      className: o("group/menu-sub-item relative", e),
      ...t
    }
  );
}
function Nn({
  asChild: e = !1,
  size: t = "md",
  isActive: r = !1,
  className: n,
  ...i
}) {
  return /* @__PURE__ */ a(
    e ? R : "a",
    {
      "data-slot": "sidebar-menu-sub-button",
      "data-sidebar": "menu-sub-button",
      "data-size": t,
      "data-active": r,
      className: o(
        "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
        "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
        t === "sm" && "text-xs",
        t === "md" && "text-sm",
        "group-data-[collapsible=icon]:hidden",
        n
      ),
      ...i
    }
  );
}
function kn({
  className: e,
  defaultValue: t,
  value: r,
  min: n = 0,
  max: i = 100,
  ...c
}) {
  const u = d.useMemo(
    () => Array.isArray(r) ? r : Array.isArray(t) ? t : [n, i],
    [r, t, n, i]
  );
  return /* @__PURE__ */ l(
    H.Root,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: r,
      min: n,
      max: i,
      className: o(
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        e
      ),
      ...c,
      children: [
        /* @__PURE__ */ a(
          H.Track,
          {
            "data-slot": "slider-track",
            className: o(
              "bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
            ),
            children: /* @__PURE__ */ a(
              H.Range,
              {
                "data-slot": "slider-range",
                className: o(
                  "bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
                )
              }
            )
          }
        ),
        Array.from({ length: u.length }, (m, s) => /* @__PURE__ */ a(
          H.Thumb,
          {
            "data-slot": "slider-thumb",
            className: "border-primary bg-background ring-ring/50 block size-4 shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
          },
          s
        ))
      ]
    }
  );
}
function zn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    ie.Root,
    {
      "data-slot": "switch",
      className: o(
        "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        ie.Thumb,
        {
          "data-slot": "switch-thumb",
          className: o(
            "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
          )
        }
      )
    }
  );
}
const Kt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ a(
  "table",
  {
    ref: r,
    className: o("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
Kt.displayName = "Table";
const qt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a("thead", { ref: r, className: o("[&_tr]:border-b", e), ...t }));
qt.displayName = "TableHeader";
const Wt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "tbody",
  {
    ref: r,
    className: o("[&_tr:last-child]:border-0", e),
    ...t
  }
));
Wt.displayName = "TableBody";
const Ut = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "tfoot",
  {
    ref: r,
    className: o(
      "bg-muted/50 border-t font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
Ut.displayName = "TableFooter";
const Xt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "tr",
  {
    ref: r,
    className: o(
      "hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors",
      e
    ),
    ...t
  }
));
Xt.displayName = "TableRow";
const Yt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "th",
  {
    ref: r,
    className: o(
      "text-muted-foreground h-10 px-2 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
Yt.displayName = "TableHead";
const Jt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "td",
  {
    ref: r,
    className: o(
      "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
Jt.displayName = "TableCell";
const Qt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  "caption",
  {
    ref: r,
    className: o("text-muted-foreground mt-4 text-sm", e),
    ...t
  }
));
Qt.displayName = "TableCaption";
const Cn = ({ ...e }) => {
  const { theme: t = "system" } = Ee();
  return /* @__PURE__ */ a(
    Ve,
    {
      theme: t,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      },
      ...e
    }
  );
};
function _n({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    Se,
    {
      role: "status",
      "aria-label": "Loading",
      className: o("size-4 animate-spin", e),
      ...t
    }
  );
}
const Sn = N.Provider, Zt = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  N.Viewport,
  {
    ref: r,
    className: o(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:top-auto sm:right-0 sm:bottom-0 sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
Zt.displayName = N.Viewport.displayName;
const ea = T(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), ta = d.forwardRef(({ className: e, variant: t, ...r }, n) => /* @__PURE__ */ a(
  N.Root,
  {
    ref: n,
    className: o(ea({ variant: t }), e),
    ...r
  }
));
ta.displayName = N.Root.displayName;
const aa = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  N.Action,
  {
    ref: r,
    className: o(
      "hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:ring-1 focus:outline-none disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
aa.displayName = N.Action.displayName;
const ra = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  N.Close,
  {
    ref: r,
    className: o(
      "text-foreground/50 hover:text-foreground absolute top-1 right-1 rounded-md p-1 opacity-0 transition-opacity group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 focus:opacity-100 focus:ring-1 focus:outline-none group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ a(Ie, { className: "h-4 w-4" })
  }
));
ra.displayName = N.Close.displayName;
const oa = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  N.Title,
  {
    ref: r,
    className: o("text-sm font-semibold [&+div]:text-xs", e),
    ...t
  }
));
oa.displayName = N.Title.displayName;
const na = d.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ a(
  N.Description,
  {
    ref: r,
    className: o("text-sm opacity-90", e),
    ...t
  }
));
na.displayName = N.Description.displayName;
const ia = T(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function In({
  className: e,
  variant: t,
  size: r,
  ...n
}) {
  return /* @__PURE__ */ a(
    $e.Root,
    {
      "data-slot": "toggle",
      className: o(ia({ variant: t, size: r, className: e })),
      ...n
    }
  );
}
export {
  wa as Accordion,
  ka as AccordionContent,
  ya as AccordionItem,
  Na as AccordionTrigger,
  za as Alert,
  _a as AlertDescription,
  Sa as AlertDialog,
  Aa as AlertDialogAction,
  ja as AlertDialogCancel,
  Ta as AlertDialogContent,
  Da as AlertDialogDescription,
  Ra as AlertDialogFooter,
  Ma as AlertDialogHeader,
  We as AlertDialogOverlay,
  qe as AlertDialogPortal,
  Pa as AlertDialogTitle,
  Ia as AlertDialogTrigger,
  Ca as AlertTitle,
  Ba as AspectRatio,
  La as Avatar,
  Oa as AvatarFallback,
  Ga as AvatarImage,
  Fa as Badge,
  Xe as Breadcrumb,
  tt as BreadcrumbEllipsis,
  Je as BreadcrumbItem,
  Qe as BreadcrumbLink,
  Ye as BreadcrumbList,
  Ze as BreadcrumbPage,
  et as BreadcrumbSeparator,
  S as Button,
  Ea as Calendar,
  at as CalendarDayButton,
  Va as Card,
  qa as CardAction,
  Wa as CardContent,
  Ka as CardDescription,
  Ua as CardFooter,
  $a as CardHeader,
  Ha as CardTitle,
  Xa as ChartContainer,
  Qa as ChartLegend,
  Za as ChartLegendContent,
  ot as ChartStyle,
  Ya as ChartTooltip,
  Ja as ChartTooltipContent,
  er as Checkbox,
  tr as Collapsible,
  rr as CollapsibleContent,
  ar as CollapsibleTrigger,
  mt as Command,
  sr as CommandDialog,
  cr as CommandEmpty,
  ur as CommandGroup,
  dr as CommandInput,
  fr as CommandItem,
  lr as CommandList,
  mr as CommandSeparator,
  pr as CommandShortcut,
  gr as ContextMenu,
  Cr as ContextMenuCheckboxItem,
  kr as ContextMenuContent,
  vr as ContextMenuGroup,
  zr as ContextMenuItem,
  Sr as ContextMenuLabel,
  hr as ContextMenuPortal,
  wr as ContextMenuRadioGroup,
  _r as ContextMenuRadioItem,
  Ir as ContextMenuSeparator,
  Tr as ContextMenuShortcut,
  xr as ContextMenuSub,
  Nr as ContextMenuSubContent,
  yr as ContextMenuSubTrigger,
  br as ContextMenuTrigger,
  nt as Dialog,
  nr as DialogClose,
  dt as DialogContent,
  ut as DialogDescription,
  ir as DialogFooter,
  lt as DialogHeader,
  st as DialogOverlay,
  it as DialogPortal,
  ct as DialogTitle,
  or as DialogTrigger,
  Mr as DropdownMenu,
  Br as DropdownMenuCheckboxItem,
  Dr as DropdownMenuContent,
  Ar as DropdownMenuGroup,
  jr as DropdownMenuItem,
  Or as DropdownMenuLabel,
  Rr as DropdownMenuPortal,
  Lr as DropdownMenuRadioGroup,
  Gr as DropdownMenuRadioItem,
  Fr as DropdownMenuSeparator,
  Er as DropdownMenuShortcut,
  Vr as DropdownMenuSub,
  Hr as DropdownMenuSubContent,
  $r as DropdownMenuSubTrigger,
  Pr as DropdownMenuTrigger,
  Kr as Form,
  Xr as FormControl,
  Yr as FormDescription,
  qr as FormField,
  Wr as FormItem,
  Ur as FormLabel,
  Jr as FormMessage,
  Qr as HoverCard,
  eo as HoverCardContent,
  Zr as HoverCardTrigger,
  ge as Input,
  to as InputGroup,
  ao as InputGroupAddon,
  ro as InputGroupButton,
  no as InputGroupInput,
  oo as InputGroupText,
  io as InputGroupTextarea,
  vt as InputOTP,
  ht as InputOTPGroup,
  wt as InputOTPSeparator,
  xt as InputOTPSlot,
  ft as Label,
  so as Menubar,
  go as MenubarCheckboxItem,
  fo as MenubarContent,
  co as MenubarGroup,
  po as MenubarItem,
  vo as MenubarLabel,
  lo as MenubarMenu,
  yt as MenubarPortal,
  uo as MenubarRadioGroup,
  bo as MenubarRadioItem,
  ho as MenubarSeparator,
  xo as MenubarShortcut,
  wo as MenubarSub,
  No as MenubarSubContent,
  yo as MenubarSubTrigger,
  mo as MenubarTrigger,
  ko as NavigationMenu,
  So as NavigationMenuContent,
  To as NavigationMenuIndicator,
  Co as NavigationMenuItem,
  Io as NavigationMenuLink,
  zo as NavigationMenuList,
  _o as NavigationMenuTrigger,
  kt as NavigationMenuViewport,
  Mo as Pagination,
  Ro as Popover,
  Ao as PopoverAnchor,
  Do as PopoverContent,
  Po as PopoverTrigger,
  jo as Progress,
  Bo as RadioGroup,
  Lo as RadioGroupItem,
  Fo as ResizableHandle,
  Oo as ResizablePanel,
  Go as ResizablePanelGroup,
  Eo as ScrollArea,
  zt as ScrollBar,
  Vo as Select,
  qo as SelectContent,
  $o as SelectGroup,
  Uo as SelectItem,
  Wo as SelectLabel,
  _t as SelectScrollDownButton,
  Ct as SelectScrollUpButton,
  Xo as SelectSeparator,
  Ko as SelectTrigger,
  Ho as SelectValue,
  St as Separator,
  It as Sheet,
  Jo as SheetClose,
  Rt as SheetContent,
  At as SheetDescription,
  Qo as SheetFooter,
  Pt as SheetHeader,
  Dt as SheetTitle,
  Yo as SheetTrigger,
  en as Sidebar,
  ln as SidebarContent,
  sn as SidebarFooter,
  cn as SidebarGroup,
  mn as SidebarGroupAction,
  fn as SidebarGroupContent,
  un as SidebarGroupLabel,
  nn as SidebarHeader,
  on as SidebarInput,
  rn as SidebarInset,
  pn as SidebarMenu,
  vn as SidebarMenuAction,
  hn as SidebarMenuBadge,
  bn as SidebarMenuButton,
  gn as SidebarMenuItem,
  xn as SidebarMenuSkeleton,
  wn as SidebarMenuSub,
  Nn as SidebarMenuSubButton,
  yn as SidebarMenuSubItem,
  Zo as SidebarProvider,
  an as SidebarRail,
  dn as SidebarSeparator,
  tn as SidebarTrigger,
  kn as Slider,
  _n as Spinner,
  zn as Switch,
  Kt as Table,
  Wt as TableBody,
  Qt as TableCaption,
  Jt as TableCell,
  Ut as TableFooter,
  Yt as TableHead,
  qt as TableHeader,
  Xt as TableRow,
  pt as Textarea,
  ta as Toast,
  aa as ToastAction,
  ra as ToastClose,
  na as ToastDescription,
  Sn as ToastProvider,
  oa as ToastTitle,
  Zt as ToastViewport,
  Cn as Toaster,
  In as Toggle,
  jt as Tooltip,
  Lt as TooltipContent,
  be as TooltipProvider,
  Bt as TooltipTrigger,
  Ue as badgeVariants,
  E as buttonVariants,
  o as cn,
  Nt as navigationMenuTriggerStyle,
  ia as toggleVariants,
  U as useFormField,
  He as useIsMobile,
  X as useSidebar
};
//# sourceMappingURL=index.js.map
